var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 810.04 810.03"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 405.03,
    cy: 405.02,
    r: 378.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 810C181.69 810 0 628.35 0 405S181.69 0 405 0s405 181.69 405 405-181.65 405-405 405zm0-757.64C210.57 52.39 52.39 210.57 52.39 405S210.57 757.64 405 757.64 757.65 599.45 757.65 405 599.47 52.39 405 52.39z",
    fill: "#cccbcb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M555.93 569.7h-66.08l-91-122.34-91 122.34h-66.13l124.06-166.77-116.93-157.16h66.72L399 358.26l83.68-112.49h66.12L432 402.71z",
    fill: "#ececec",
    opacity: 0.9
  })));
}

export default SvgCloseModal;